import { useRoleContext } from './RoleContext';

export const usePermissions = () => useRoleContext();

export default usePermissions;
